import {Fragment, useContext, useMemo} from 'react';

import {Icon, OsIcon, BrowserIcon} from 'components';
import {UserContext} from 'context';
import {TimeFormatSpecificity} from 'enums';
import {UserConnectionInfo} from 'types';
import {dateUtils, formatDate} from 'utils';

type Props = {
    info: UserConnectionInfo
}

export const ConnectionInfo: React.FC<Props> = ({info}) => {
    const {settings: {common: {timeZone, dateFormat, timeFormat}}} = useContext(UserContext);

    const dateTimeFormat = useMemo(() =>
        dateUtils.getDateTimeFormat(dateFormat, timeFormat, TimeFormatSpecificity.Seconds),
    [dateFormat, timeFormat]);

    return (
        <Fragment>
            <div className='tw-flex tw-flex-wrap tw-items-center tw-font-bold tw-mb-1'>
                <div className='tw-mr-1'>{info.ip}</div>
                {info.location && <div className='tw-mr-1'>{`(${info.location})`}</div>}
                <OsIcon os={info.os} osVersion={info.osVersion} className='tw-mr-1 tw-mb-0.5' />
                <BrowserIcon browser={info.browser} browserVersion={info.browserVersion} className='tw-mb-0.5' />
            </div>
            <div className='tw-flex tw-items-center tw-text-default-dimmed'>
                <Icon name='clock' size='xs' className='tw-mr-1' />
                {formatDate(info.date, timeZone, dateTimeFormat)}
            </div>
        </Fragment>
    );
};